import Editor from 'components/Editor/Editor';
import React, { useRef, useState } from 'react';

const CreateLetterEditor = ({setJsonContent,setHtmlContent,jsonContent,tokenList}) => {
  const emailEditorRef = useRef({ projectId: 195575 });

  const [enableEdit, setEnableEdit] = useState(true);


  return (
    <div className="create-letter-editor">
      <Editor
        setJsonContent={setJsonContent}
        setHtmlContent={setHtmlContent}
        preview={enableEdit}
        jsonContent={jsonContent}
        tokenList={tokenList}
        emailEditorRef={emailEditorRef}
      />
    </div>
  )
}

export default CreateLetterEditor